import { nanoid } from 'nanoid';

export const TablePlaceholder = ({ rows, cols }: { rows: number; cols: number }) => {
  return (
    <>
      {[...Array(rows)].map(() => (
        <tr key={nanoid()}>
          {[...Array(cols)].map(() => (
            <td key={nanoid()}>
              <p className="placeholder-glow">
                <span
                  className="placeholder col-12"
                  style={{
                    height: '24px',
                  }}
                ></span>
              </p>
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};
